import { render, staticRenderFns } from "./view-lead.vue?vue&type=template&id=6f1222c9&scoped=true"
import script from "./view-lead.vue?vue&type=script&lang=js"
export * from "./view-lead.vue?vue&type=script&lang=js"
import style0 from "./view-lead.vue?vue&type=style&index=0&id=6f1222c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1222c9",
  null
  
)

export default component.exports